<template>
  <div>
    <div v-html="getMainContent(collection)" class="collection__main-content col-12 col-m-5" />
    <div v-if="hasVideo(collection)" class="collection__main-content-video col-12 col-m-5">
      <SfVideo
        class="collection__video desktop-only"
        :src="getDesktopVideo(collection)"
        :poster="getDesktopVideoPoster(collection)"
        :auto-play="true"
      />
      <SfVideo
        class="collection__video smartphone-only"
        :src="getMobileVideo(collection)"
        :poster="getMobileVideoPoster(collection)"
        :auto-play="true"
      />
    </div>
    <div v-else class="collection__image-wrapper">
      <img
        class="collection__image img-block"
        :src="getDesktopContentImage(collection)"
        alt=""
      >
    </div>
  </div>
</template>

<script type="ts">
import { defineComponent } from '@nuxtjs/composition-api';
import { SfVideo } from '~/components';
import collectionGetters from '~/modules/collections/getters/collectionGetters';

export default defineComponent({
  components: {
    SfVideo,
  },
  props: {
    collection: {
      type: Object,
      default: null,
    },
  },
  setup() {

    return {
      ...collectionGetters
    };
  }
});
</script>

<style lang="scss" scoped>
.collection {
  &__item-image {
    @include for-mobile {
      margin: var(--spacer-lg) 0;
    }
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;

    @include for-desktop {
      width: 100%;
    }
  }

  &__main {
    @include for-desktop($s) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: var(--spacer-base);
      margin-bottom: var(--spacer-base);
      overflow: hidden;
    }

    @include for-desktop($t) {
      flex-direction: row;
      gap: var(--sp_12);
    }

    @include for-desktop($dl) {
      gap: var(--sp_16);
    }

    @include for-mobile($s) {
      margin: var(--sp_16) 0;
    }

    &-content {
      display: flex;
      flex-direction: column;

      @include for-desktop($t) {
        width: 472px;
      }

      @include for-desktop($ds) {
        width: 636px;
      }

      @include for-desktop($dl) {
        width: 784px;
      }

      ::v-deep {
        .collection__main-content-image {
          margin: var(--spacer-xs) 0 var(--spacer-lg);
        }

        p {
          font-size: var(--font-size--base);
          line-height: var(--line-height--base);
          margin: 0 0 var(--sp_16);
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background-color: var(--c-grey-3);
            border-radius: 5px;
          }

          @include for-desktop($s) {
            max-height: 310px;
            font-size: var(--font-size--m);
            font-weight: var(--font-weight--medium);
            line-height: var(--line-height--base);
            letter-spacing: .6px;
            padding-right: 15px;
          }

          @include for-desktop($t) {
            max-height: 228px;
            margin: 0;
          }

          @include for-desktop($ds) {
            max-height: 310px;
          }

          @include for-desktop($dl) {
            max-height: 376px;
          }

          @include for-mobile($s) {
            max-height: 286px;
            font-size: var(--font-size--sm);
            line-height: var(--line-height--sm);
            padding-right: 27px;
          }

          .collection__description-title {
            display: block;
            font-family: var(--font-family--secondary);
            color: var(--c-black);
            font-size: var(--font-size--xl);
            font-weight: var(--font-weight--bold);
            line-height: var(--line-height--xl);
            margin-bottom: var(--sp_16);

            @include for-desktop($s) {
              font-weight: var(--font-weight--medium);
              line-height: var(--line-height--xxl);
              margin-bottom: var(--sp_4);
            }
          }
        }

        img {
          display: block;
          width: 100%;
          max-width: 100%;
        }

        .bottom {
          margin-top: auto;
        }

        .right {
          margin-left: auto;
        }
      }
    }
  }
}

.collection__image-wrapper {
  background: var(--togas-grey-400-color);

  @include for-smartphone($tablet-min) {
    position: relative;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
  }

  @include for-desktop {
    width: 50%;
    max-height: 375px;
  }
}
</style>
